import scrollMonitor from 'scrollmonitor'
import { CountUp } from 'countup.js'

class CountingEntry {
  constructor () {
    this._element = document.querySelectorAll('.o-counting-entry')

    this._init()
  }

  _init() {

    for (let i=0; i < this._element.length; i++) {
      let el = this._element[i]
      let valueFrom = parseInt(el.dataset.countFrom) || 0
      let valueTo = parseInt(el.dataset.countTo) || 0
      let options = {
        startVal: valueFrom,
        duration: 2,
        separator: (el.dataset.separator == 0) ? '' : '.'
      }
      let numAnim = new CountUp(el, valueTo, options)

      let watcher = scrollMonitor.create(el, -200)
      watcher.enterViewport(() => {
        numAnim.start()
      })
    }
  }
}

export default new CountingEntry()
